/**
 * Crème Berry — central site content.
 *
 * This is the single place to edit the site's business content. Anything marked
 * `TODO` needs a real value from the owner before launch.
 */

/* ── Business basics ──────────────────────────────────────── */

export const INSTAGRAM_URL = 'https://www.instagram.com/cremeberry.sf/';
export const INSTAGRAM_HANDLE = '@cremeberry.sf';

// TODO: confirm the contact / inquiry-form destination email.
export const CONTACT_EMAIL = 'hello@cremeberrysf.com';

// TODO: confirm starting price.
export const STARTING_PRICE = 'from $55';

// TODO: confirm lead time + deposit policy.
export const LEAD_TIME = 'Please order at least 3 days ahead.';

export const SERVICE_AREA = 'San Francisco & the Bay Area';
export const FULFILLMENT = 'Pickup in San Francisco, or Bay Area delivery 9–11pm.';

/* ── Flavors ──────────────────────────────────────────────── */
// TODO: swap `image` paths for real flavor photos in /public/images.

export interface Flavor {
  id: string;
  name: string;
  detail: string;
  image: string;
}

export const FLAVORS: Flavor[] = [
  { id: 'strawberry', name: 'STRAWBERRY', detail: 'Fresh strawberries & cream', image: '' },
  { id: 'mango', name: 'MANGO', detail: 'Ripe mango & light cream', image: '' },
  { id: 'oreo', name: 'OREO', detail: 'Cookies & cream', image: '' },
  { id: 'matcha', name: 'MATCHA', detail: 'Stone-ground matcha cream', image: '' },
];

/* ── How it works ─────────────────────────────────────────── */

export interface Step {
  number: string;
  title: string;
  detail: string;
}

export const HOW_IT_WORKS: Step[] = [
  {
    number: '01',
    title: 'PICK YOUR LETTERS OR NUMBER',
    detail: 'Spell a name, initials, or an age — like “K” for Kevin or “3” for a third birthday.',
  },
  {
    number: '02',
    title: 'CHOOSE A FLAVOR',
    detail: 'Strawberry, mango, oreo, or matcha — a delicate cream-tart base, baked fresh.',
  },
  {
    number: '03',
    title: 'WE DECORATE',
    detail: 'Finished by hand with fresh fruit, macarons, and seasonal flowers.',
  },
];

/* ── Occasions ────────────────────────────────────────────── */

export interface Occasion {
  id: string;
  heading: string;
  subheading: string;
  image?: string;
  imageClassName?: string;
}

export const OCCASIONS: Occasion[] = [
  {
    id: 'birthdays',
    heading: 'BIRTHDAYS',
    subheading: 'Spell their name or age — for kids and grown-ups alike',
    image: '/images/birthday-letter-cakes.png',
  },
  {
    id: 'anniversaries',
    heading: 'ANNIVERSARIES',
    subheading: 'Initials, “LOVE”, or the number of years together',
    image: '/images/anniversary-heart-cakes.png',
  },
  {
    id: 'celebrations',
    heading: 'CELEBRATIONS',
    subheading: 'Milestone birthdays, graduations, and every party in between',
    image: '/images/celebrations-number-cake.png',
  },
];

/* ── Reviews ──────────────────────────────────────────────── */
// TODO: replace with real reviews (the IG "REVIEWS" highlight is a good source).

export interface Review {
  id: string;
  quote: string;
  author: string;
}

export const REVIEWS: Review[] = [
  {
    id: 'r1',
    quote: 'The most beautiful cake at my daughter’s party — and it tasted even better than it looked.',
    author: 'Jenny L., San Francisco',
  },
  {
    id: 'r2',
    quote: 'Ordered a number “40” for my husband. Everyone asked where I got it. Will be back!',
    author: 'Maria S., Daly City',
  },
  {
    id: 'r3',
    quote: 'Fresh, gorgeous, and delivered right on time. Exactly what I hoped for.',
    author: 'Annie T., Oakland',
  },
];

/* ── FAQ ──────────────────────────────────────────────────── */

export interface FaqItem {
  q: string;
  a: string;
}

export const FAQ: FaqItem[] = [
  {
    q: 'How do I place an order?',
    a: 'Message us on Instagram with your event date, the letters or number you’d like, a flavor, and whether you’d like pickup or delivery. We’ll confirm the details and send a quote. You can also use the form on this page.',
  },
  {
    q: 'How far in advance should I order?',
    a: 'Please order at least 3 days ahead. Popular weekends and holidays book up sooner, so earlier is always better.', // TODO confirm lead time
  },
  {
    q: 'Where do you deliver?',
    a: 'We offer pickup in San Francisco and delivery across the Bay Area between 9–11pm. Delivery fees depend on distance — we’ll include it in your quote.', // TODO confirm fee/zone
  },
  {
    q: 'What flavors do you offer?',
    a: 'Strawberry, mango, oreo, and matcha, each on our signature cream-tart base.',
  },
  {
    q: 'Do your cakes contain allergens?',
    a: 'Our cakes are made in a kitchen that handles dairy, eggs, gluten, and nuts. Please tell us about any allergies when you order.', // TODO confirm
  },
];

/* ── About ────────────────────────────────────────────────── */
// TODO: edit this to the real family story.

export const ABOUT = {
  heading: 'A LITTLE FAMILY KITCHEN IN SAN FRANCISCO',
  body: 'Crème Berry started at home, making custom letter and number cakes for friends and family. Every cake is still made by hand, to order, with fresh fruit and flowers — a little piece of someone’s celebration, baked with care in San Francisco.',
  image: '/images/kitchen-sf.png',
  imageAlt: 'Crème Berry’s San Francisco kitchen — a naked layer cake on a turntable in warm golden light.',
};

/* ── Hero ─────────────────────────────────────────────────── */

export const HERO = {
  // TODO: add a showstopper photo to /public/images and set this path.
  image: '',
  heading: ['LETTER & NUMBER', 'CAKES'],
  tagline: 'Custom cream-tart cakes for birthdays, anniversaries & parties — made fresh in San Francisco.',
};
